import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "FORQ",
    description: "FORQ electric forklifts lift up to 5,000 kg, run up to 16 hours on a charge and cost far less to run than diesel. Explore the FQ-Series in 3D, configure yours and get a quote.",
    url: getOrigin()
}

export const navItems = [
    { label: "Technology", href: '#power' },
    { label: "Safety", href: '#safety' },
    { label: "Configure", href: '#configure' },
    { label: "Savings", href: '#savings' },
    { label: "FAQ", href: '#faq' }
]
